// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const revokeApplicationAuthorizationPathParamsSchema = z.object({
  id: z.number().int().describe("Application ID"),
});

export const revokeApplicationAuthorizationHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description application authorization revoked
 */
export const revokeApplicationAuthorization200Schema = z.unknown();

/**
 * @description unauthorized
 */
export const revokeApplicationAuthorization401Schema = z.unknown();

/**
 * @description application not found
 */
export const revokeApplicationAuthorization404Schema = z.unknown();

export const revokeApplicationAuthorizationMutationResponseSchema = z.lazy(() => revokeApplicationAuthorization200Schema);
